import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { gptPageMockupContentConfigs } from "@/puck/blocks/content/gptPageMockupConfigs";

export const gptPageMockupConfigs: Pick<LandingComponents, "LpGptPageMockup"> = {
  LpGptPageMockup: {
    ...gptPageMockupContentConfigs.GptPageMockup,
    label: "GPT page mockup (marketing)",
  },
};
